import useAppStore from '$appStore'
import { CountryLocaleOptions, LocaleOptions } from '$constants'
import { CompanyPreferences } from '$utils'
/**
 * Formats percentage values to the expected 2 decimal places
 * NOTE: percentage should be decimal value e.g 0.15 for 15%
 * @param percentage the percentage value to be formatted (should be in decimal form e.g. between 0 and 1 if between 0% and 100%)
 * @returns the formatted percentage value
 */
export function formatDecimalToPercentage(
  percentage: number | null | undefined
): string {
  if (!percentage) return '0.00'
  return (percentage * 100).toFixed(2)
}

/**
 * Formats currency values to the expected 2 decimal places and adds a '$' infront
 * @param currency the currency value to be formatted
 * @returns the formatted currency value
 */
export function formatPercent(
  percent: number | null | undefined,
  hideSymbol?: boolean,
  isDecimal: boolean = false
): string {
  const companyLocale: string = useAppStore
    .getState()
    .activeCompany?.preference(CompanyPreferences.Locale) as string

  const config: LocaleOptions =
    CountryLocaleOptions[companyLocale] || CountryLocaleOptions['default']
  const numberFormat: Intl.NumberFormat = Intl.NumberFormat(config.locale, {
    style: 'percent',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })
  let value: string = ''

  if (!percent) {
    value = numberFormat.format(0)
  } else {
    if (!isDecimal) {
      percent = +percent / 100
    }

    value = numberFormat.format(percent)
  }

  if (hideSymbol) {
    value = value.slice(0, -1)
  }

  return value
}
